import { ITopicList } from "@/api/topics";
import { Edit } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useDialogs } from "@toolpad/core";
import { EditTopicDialog } from "./dialogs/EditTopicDialog";

interface IProps {
    topic: ITopicList;
}

export const EditTopicButton = ({ topic }: IProps) => {
    const dialogs = useDialogs();

    const handleEdit = async () => {
        await dialogs.open(EditTopicDialog, { topic });
    };

    return (
        <GridActionsCellItem
            icon={
                <Tooltip title="Edit Topic">
                    <Edit />
                </Tooltip>
            }
            label="Edit"
            onClick={handleEdit}
        />
    );
};
